import Image from "next/image";
import Link from "next/link";

import { useTranslation } from "@flare/i18n";
import { Button } from "@flare/ui/components";

import mainImg from "@/../public/next/images/globe.png";

import { BackButton } from "../components/back-button";
import { Footer } from "../components/footer";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";
import { StepSubtitle } from "../components/step-subtitle";
import { StepTitle } from "../components/step-title";

export default function UnsupportedConfirmed() {
  const { t } = useTranslation();

  return (
    <>
      <StepContainer>
        <StepContent>
          <BackButton />
          <div className="m-auto flex max-w-[520px] flex-col items-center justify-center">
            <Image src={mainImg} alt={t("FUNNEL_UNSUPPORTED_IMAGE_ALT")} />
            <StepTitle>{t("FUNNEL_UNSUPPORTED_CONFIRMED_TITLE")}</StepTitle>
            <StepSubtitle className="text-pretty pt-sp-1">
              {t("FUNNEL_UNSUPPORTED_CONFIRMED_TEXT")}
            </StepSubtitle>
            <Button asChild type="button" className="my-sp-9 w-full md:w-fit">
              <Link href="/">{t("FUNNEL_UNSUPPORTED_CONFIRMED_BUTTON")}</Link>
            </Button>
          </div>
        </StepContent>
      </StepContainer>
      <Footer />
    </>
  );
}
